import React from "react";
import { Checkbox, TableCell, TableRow } from "@mui/material";
import moment from "moment";
import { capitalizeFirstLetter } from "../../../../../constants";

const GroupsTableRow = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  onRowClick,
}) => {
  return (
    <TableRow
      hover
      role="checkbox"
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{ cursor: "pointer", height: 48, background: numberType ? "#F2F2F2" : "#fff" }}
      onClick={() => onRowClick && onRowClick(row)}
    >
      <TableCell
        padding="checkbox"
        style={{ background: "#fff" }}
        onClick={(event) => {
          event.stopPropagation();
          handleClickRow(event, row.id);
        }}
      >
        <Checkbox
          color="primary"
          checked={isItemSelected}
          inputProps={{ "aria-labelledby": labelId }}
        />
      </TableCell>
      <TableCell padding="none" style={cellTitleStyles}>
        {row?.name || ""}
      </TableCell>
      <TableCell style={cellStyles} title={row?.id}>
        {row?.id}
      </TableCell>
      <TableCell style={cellStyles}>
        {row?.createdByData?.userName || row?.createdBy || ""}
      </TableCell>
      <TableCell style={cellStyles}>
        {row?.createdAt?.seconds
          ? moment.unix(row.createdAt.seconds).format("MM-DD-YYYY HH:mm")
          : ""}
      </TableCell>
      <TableCell style={cellStyles}>
        {Array.isArray(row?.members) ? row.members.length : 0}
      </TableCell>
      <TableCell style={cellStyles}>
        {Array.isArray(row?.quicktales) ? row.quicktales.length : 0}
      </TableCell>
      <TableCell style={cellStyles}>
        {capitalizeFirstLetter(row?.status || "")}
      </TableCell>
    </TableRow>
  );
};

export default GroupsTableRow;

const cellTitleStyles = {
  border: "1px solid #BABABA",
  paddingLeft: 5,
  color: "#00A7CD",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
};

const cellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
};
